import UserProvider from "./UserContext";
import UserList from "./UserList";
import UserForm from "./UserForm";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const UsersPage = () => {
  const { t } = useTranslation();

  useEffect(() => (document.title = t("AtVitae - User Management")), [t]);

  return (
    <UserProvider>
      <UserForm />
      <UserList />
    </UserProvider>
  );
};

export default UsersPage;
